import { render, staticRenderFns } from "./addColumn.vue?vue&type=template&id=e3bae236&scoped=true&"
import script from "./addColumn.vue?vue&type=script&lang=js&"
export * from "./addColumn.vue?vue&type=script&lang=js&"
import style0 from "./addColumn.vue?vue&type=style&index=0&id=e3bae236&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e3bae236",
  null
  
)

export default component.exports